import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import emptyStateBg from 'modules/pages/lib/assets/emptyStateBackground.png'
import emptyStateIcons from 'modules/pages/lib/assets/emptyStateIcons.png'
import { usePagesContext } from 'modules/pages/lib/hooks/usePagesContext'

interface EmptyStateProps {
  setOpenModal: (open: boolean) => void
}
export const EmptyState = ({ setOpenModal }: EmptyStateProps) => {
  const { canEditPages } = usePagesContext()
  return (
    <Box alignItems="center" justifyContent="center" height="full" width="full" position="relative">
      <Box
        alignItems="center"
        justifyContent="center"
        maxWidth="s600"
        position="relative"
        textAlign="center"
      >
        <Box gap="s16" alignItems="center" justifyContent="center" position="relative">
          <img src={emptyStateBg} alt="Page empty state background" width="430px" height="270px" />
          <img
            src={emptyStateIcons}
            alt="Page empty state icons"
            width="220px"
            height="174px"
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          />
        </Box>
        <Box gap="s16" alignItems="center" justifyContent="center">
          <Text.Header1 color="grey1000" weight="semibold">
            {canEditPages
              ? i18n.t('pages.empty_state.admin.title')
              : i18n.t('pages.empty_state.user.title')}
          </Text.Header1>
          <Text.Normal color="grey700" size="200">
            {canEditPages
              ? i18n.t('pages.empty_state.admin.description')
              : i18n.t('pages.empty_state.user.description')}
          </Text.Normal>
          {canEditPages && (
            <Box paddingTop="s16">
              <F0Button label="Start now" size="lg" onClick={() => setOpenModal(true)} />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}
